import { render, staticRenderFns } from "./DpeContactForm.vue?vue&type=template&id=f07061ca&scoped=true"
import script from "./DpeContactForm.vue?vue&type=script&lang=js"
export * from "./DpeContactForm.vue?vue&type=script&lang=js"
import style0 from "./DpeContactForm.vue?vue&type=style&index=0&id=f07061ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07061ca",
  null
  
)

export default component.exports